/** Label for results entry navigation when exam results may already exist. */
export function resultsEntryButtonLabel(exam) {
  return exam?.results_status === 'published' ? 'Update Results' : 'Enter Results';
}

export function resultsEntryPageTitle(exam) {
  return exam?.results_status === 'published' ? 'Update Results' : 'Enter Results';
}
